import axios from 'axios'

import config from '../../config'

const updatePriority = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/Priorities`
  return axios.put(url, data)
}

export default updatePriority
